import React from "react";
import TitoloColore from "../commons/TitoloColore";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import cms from "../images/VisiteMediche/cms.jpg"
import {Link} from "react-router-dom";
import certificato from "../images/Nuoto/corsiNuoto/licenza_snf attestato 2023-2024_page-0001.jpg";


function VisiteMediche() {
    return(
        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Visite mediche"} backgroundColor={"#003F83"} />
            <div style={{padding: "1em"}}>
                <figure className="text-center" style={{padding: "3em"}}>
                    <blockquote className="blockquote">
                        <p>
                            Per partecipare a tutti i corsi e le attività sportive, è obbligatorio presentare il certificato medico non agonistico
                            <br/>
                            <br/>

                            <Link to={"https://www.visitamedicasportiva.it/"} style={{color: "black", fontSize: "26px", fontWeight: "bold"}}>Prenota qui</Link>
                            <br/>
                            la tua visita medica presso il
                            <br/>
                            <br/>

                            <div className="m-auto d-flex flex-row justify-content-center" style={{maxWidth: "500px"}}>
                                <img src={cms} className="img-fluid " alt="..." />
                            </div>

                        </p>
                    </blockquote>
                </figure>
            </div>
        </div>
    )
}

export default VisiteMediche